import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const isCurrentRouteError404Page = createSelector(getCurrentRoute, (current) => current?.url?.startsWith('/404') || false);
